import { Info } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { type MessageKey, useT } from "@/lib/i18n"

/**
 * A quiet ⓘ in the page header for presenters and curious experts: one or two plain sentences on
 * the mechanism behind the screen. Closed by default; never marketing copy.
 */
export function HowItWorks({ lines }: { lines: readonly MessageKey[] }) {
  const t = useT()
  return (
    <Popover>
      <PopoverTrigger
        aria-label={t("ws.how.label")}
        className="flex size-7 items-center justify-center rounded-full text-subtle-foreground outline-none transition-colors hover:bg-muted hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/30 data-[popup-open]:bg-muted data-[popup-open]:text-foreground"
      >
        <Info className="size-4" aria-hidden />
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 gap-2 rounded-2xl p-4">
        <p className="text-xs font-medium text-muted-foreground">{t("ws.how.label")}</p>
        {lines.map((key) => (
          <p key={key} className="text-[13px] leading-relaxed text-foreground">
            {t(key)}
          </p>
        ))}
      </PopoverContent>
    </Popover>
  )
}
